// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/common/closedBanner/closedBanner.scss
// module id = 728
// module chunks = 0